// 统计
import * as activity from "activityConfigES";

/**
 * listen() 点击触发
 * ①：统计点击量
 * activity.listen({'btn1': '按钮1', 'btn2': '按钮2', 'btn3': '按钮3'}, 'click')
 * ②：统计点击人数
 * activity.listen({'btn1': '按钮1', 'btn2': '按钮2', 'btn3': '按钮3'}, 'user')
 */

export const init = function () {
  activity.stat();
  activity.listen({ 'j-open-box': '点击签到次数', 'j-egg-start': '点击抽奖次数' }, 'click')
  activity.listen({ 'j-open-box': '点击签到人数', 'j-egg-start': '点击抽奖人数' }, 'user')
  return activity;
};


